module.exports = __webpack_public_path__ + "img/img5.a30746c7.png";